import React from 'react';
import { EngagementCard } from './engagement-card';

export const EngagementCards = ({ activeCards }) => {
  const cardsToRender = activeCards.map((card) => <EngagementCard key={card.id} card={card} />);
  return <>{cardsToRender}</>;
};
